import script from "./DefaultLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./DefaultLayout.vue?vue&type=script&setup=true&lang=js"

import "./DefaultLayout.vue?vue&type=style&index=0&id=a3b34cee&lang=css"

const __exports__ = script;

export default __exports__